import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0ce57cf2")

_pushScopeId("data-v-0ce57cf2")
const _hoisted_1 = { class: "df-middle" }
const _hoisted_2 = { class: "d-ib icon v-middle mr-8" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_t = _resolveComponent("t")

  return (_openBlock(), _createBlock("div", {
    class: ["connect df-middle df-center", ['', 'success', 'error'][+_ctx.state.value]]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("span", _hoisted_2, [
        _createVNode(_component_Pic, {
          src: "link",
          width: "14",
          height: "14",
          style: {"vertical-align":"top"}
        })
      ]),
      _createVNode(_component_t, {
        as: "p",
        path: _ctx.stateList[+_ctx.state.value].path
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.stateList[+_ctx.state.value].text), 1)
        ]),
        _: 1
      }, 8, ["path"])
    ])
  ], 2))
})